import { RoommateData } from 'src/features/multi-occupancy/types';

export class ProcessAmendDto {
    readonly vita_ref: string;

    readonly transaction_id: string | null;

    readonly room_mates: RoommateData[];

    constructor(vitaRef: string, transaction_id: string | null, roommates: RoommateData[]) {
        this.vita_ref = vitaRef;
        this.transaction_id = transaction_id;
        this.room_mates = roommates;
    }
}
